// ABOUTME: Renders the open session-change dialog, mounted once in the platform shell
// ABOUTME: Pusher refreshes pages behind it; closing after a change refreshes the shared events
import { browserTimeZone } from '@execonline-inc/slot-picker.private';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../CurrentUser/Store';
import EventsStore from '../../EventsStore';
import CancelSessionModal from './CancelSessionModal';
import CoachingSchedulerModal from './CoachingSchedulerModal';
import { sessionChangeStore } from './SessionChangeStore';

interface Props {
  // The calendar, upcoming events and event views read this store, so it is refreshed after any
  // change; a page that holds its own copy (the dashboard) passes its refresh when opening.
  eventsStore: EventsStore;
}

const SessionChangeDialogs = ({ eventsStore }: Props) => {
  const { dialog, changed } = sessionChangeStore;
  const locale = currentUserStore.preferredLanguage.getOrElseValue('en');
  const close = () => {
    if (sessionChangeStore.close()) {
      eventsStore.refresh();
    }
  };

  switch (dialog.kind) {
    case 'closed': {
      return <></>;
    }
    case 'reschedule': {
      return (
        <CoachingSchedulerModal
          schedulerHref={dialog.link.href}
          purpose="reschedule"
          participantEmail={nothing()}
          locale={locale}
          onBooked={changed}
          onClose={close}
        />
      );
    }
    case 'cancel': {
      return (
        <CancelSessionModal
          cancelHref={dialog.target.link.href}
          session={dialog.target.session}
          timeZone={browserTimeZone()}
          locale={locale}
          onCancelled={changed}
          onClose={close}
        />
      );
    }
  }
};

export default observer(SessionChangeDialogs);
